import { NoticeConst, NoticeLabelConst } from "../../constants/NoticeConst";
// 属性に応じたバッジを生成するヘルパー関数
export const GetNoticeBadge = (type: number) => {
    switch (type) {
      case NoticeConst.Important: // Important
        return <span className="bg-red-100 text-red-700 border border-red-200 px-1.5 py-0.5 rounded text-xs font-bold whitespace-nowrap">{NoticeLabelConst[NoticeConst.Important]}</span>;
      case NoticeConst.System: // System
        return <span className="bg-orange-100 text-orange-800 border border-orange-200 px-1.5 py-0.5 rounded text-xs font-bold whitespace-nowrap">{NoticeLabelConst[NoticeConst.System]}</span>;
      case NoticeConst.Business: // Business
        return <span className="bg-green-100 text-green-700 border border-green-200 px-1.5 py-0.5 rounded text-xs font-bold whitespace-nowrap">{NoticeLabelConst[NoticeConst.Business]}</span>;
      case NoticeConst.Normal:
      default: // Normal (0)
        return <span className="bg-gray-100 text-gray-600 border border-gray-200 px-1.5 py-0.5 rounded text-xs font-bold whitespace-nowrap">{NoticeLabelConst[NoticeConst.Normal]}</span>;
    }
  };
